// src/components/onboarding/ExistingWebsiteScreen.js
// Onboarding fork: "Do you have an existing website?"
// Both paths are equally valid — this is not a fallback.

import React, { useState } from 'react';

const ExistingWebsiteScreen = ({ initialValue, onContinue, onBack }) => {
  const [selected, setSelected] = useState(initialValue); // true, false, or null

  const handleSelect = (value) => {
    setSelected(value);
  };

  const handleContinue = () => {
    if (selected === null || selected === undefined) return;
    onContinue(selected);
  };

  const cardBase = {
    width: '100%',
    padding: '24px',
    background: '#fff',
    border: '2px solid #E5E7EB',
    borderRadius: '12px',
    cursor: 'pointer',
    textAlign: 'left',
    fontFamily: "'Montserrat', sans-serif",
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    userSelect: 'none',
  };

  const selectedStyle = {
    borderColor: '#7c3aed',
    boxShadow: '0 0 0 1px #7c3aed',
  };

  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <h1 style={{ fontSize: '22px', fontWeight: 700, color: '#111827', margin: 0 }}>
          Do you have an existing website?
        </h1>
        <p style={{ fontSize: '14px', color: '#6B7280', margin: 0 }}>
          Either way, we've got you covered.
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '24px' }}>
        {/* "Yes" card */}
        <div
          role="button"
          tabIndex={0}
          onClick={() => handleSelect(true)}
          onKeyDown={(e) => e.key === 'Enter' && handleSelect(true)}
          style={{
            ...cardBase,
            ...(selected === true ? selectedStyle : {}),
          }}
          onMouseEnter={(e) => { if (selected !== true) e.currentTarget.style.borderColor = '#c4b5fd'; }}
          onMouseLeave={(e) => { if (selected !== true) e.currentTarget.style.borderColor = '#E5E7EB'; }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
            <span style={{ fontSize: '26px', lineHeight: 1, flexShrink: 0 }}>🌐</span>
            <div>
              <p style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937', margin: '0 0 6px' }}>
                Yes, I have a website
              </p>
              <p style={{ fontSize: '14px', color: '#6B7280', margin: 0, lineHeight: 1.5 }}>
                Great — Divine Frameworks works alongside your site. Set up your services and add a booking button.
              </p>
            </div>
          </div>
          {selected === true && (
            <div style={{
              marginTop: '12px', marginLeft: '40px',
              fontSize: '12px', color: '#7c3aed', fontWeight: 500,
            }}>
              ✓ Selected
            </div>
          )}
        </div>

        {/* "No" card */}
        <div
          role="button"
          tabIndex={0}
          onClick={() => handleSelect(false)}
          onKeyDown={(e) => e.key === 'Enter' && handleSelect(false)}
          style={{
            ...cardBase,
            ...(selected === false ? selectedStyle : {}),
          }}
          onMouseEnter={(e) => { if (selected !== false) e.currentTarget.style.borderColor = '#c4b5fd'; }}
          onMouseLeave={(e) => { if (selected !== false) e.currentTarget.style.borderColor = '#E5E7EB'; }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
            <span style={{ fontSize: '26px', lineHeight: 1, flexShrink: 0 }}>✨</span>
            <div>
              <p style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937', margin: '0 0 6px' }}>
                No, I need a website
              </p>
              <p style={{ fontSize: '14px', color: '#6B7280', margin: 0, lineHeight: 1.5 }}>
                Build a beautiful site with our website builder — no coding needed.
              </p>
            </div>
          </div>
          {selected === false && (
            <div style={{
              marginTop: '12px', marginLeft: '40px',
              fontSize: '12px', color: '#7c3aed', fontWeight: 500,
            }}>
              ✓ Selected
            </div>
          )}
        </div>
      </div>

      {/* Navigation */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '32px' }}>
        <span
          role="button"
          tabIndex={0}
          onClick={onBack}
          onKeyDown={(e) => e.key === 'Enter' && onBack()}
          style={{
            fontSize: '14px', color: '#6B7280', cursor: 'pointer',
            userSelect: 'none', fontFamily: "'Montserrat', sans-serif",
          }}
        >
          ← Back
        </span>
        <button
          type="button"
          onClick={handleContinue}
          disabled={selected === null || selected === undefined}
          style={{
            padding: '10px 28px',
            background: selected !== null && selected !== undefined ? '#7c3aed' : '#D1D5DB',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: 600,
            cursor: selected !== null && selected !== undefined ? 'pointer' : 'not-allowed',
            fontFamily: "'Montserrat', sans-serif",
            transition: 'background 0.2s ease',
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default ExistingWebsiteScreen;
